import axios from "../axios";
import api from "@/store/api";

export const state = {
  prompts: null,
  result : null,
}

export const mutations = {
  SET_YT_THUMBNAIL_STATE(state, { key, value }) {
    state[key] = value
  },
}

export const actions = {
  async get_youtube_thumbnail_prompts ({ commit }) {
    try {
      commit('SET_REQ_STATUS', 'fetching')
      const {data} = await axios.get(api.youtubeThumbnail.prompts)
      const { _rev, ...config } = data
      commit('SET_YT_THUMBNAIL_STATE', {key: 'prompts', value: config})
      commit('SET_REQ_STATUS', 'idles')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async update_youtube_thumbnail_prompts ({ state, commit }) {
    try {
      commit('SET_REQ_STATUS', 'sending')
      await axios.put(api.youtubeThumbnail.prompts, state.prompts)
      commit('SET_REQ_STATUS', 'idles')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async generate_youtube_thumbnail ({ commit }, payload) {
    try {
      commit('SET_REQ_STATUS', 'generating')
      const {data} = await axios.post(api.youtubeThumbnail.generate, payload)
      commit('SET_YT_THUMBNAIL_STATE', {key: 'result', value: data})
      commit('SET_REQ_STATUS', 'idles')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
    }
  }
}